import { SB } from '@play-co/replicant';

export default {
  seenAdTimestamps: SB.array(SB.int()),
};
